import React, { useRef, useState } from "react";
import cencle from "../images/cancel.png";
import { useDispatch, useSelector } from "react-redux";

import updateToggle from "../redux/todos/thunk/updateToggle";
import updateColor from "../redux/todos/thunk/updateColor";
import deleteTodo from "../redux/todos/thunk/deteleTodo";
import { editbtn, update } from "../redux/todos/actions";
import updateTodo from "../redux/todos/thunk/updateTodo";

export default function Todo({ todo }) {
  const { text, color, completed, id } = todo;
  const states = useSelector((state) => state);
  console.log(states);
  const dispatch = useDispatch();
  const updateText = useRef(null);
  let inputsValue = "";
  // let state = false;
  // let [state, setState] = useState(false);

  const { stat } = states;
  const { status, ids } = stat;

  const checked = (todoId) => {
    dispatch(updateToggle(completed, todoId));
  };
  const colorSelect = (color, todoId) => {
    dispatch(updateColor(color, todoId));
  };

  const deleting = (todoId) => {
    dispatch(deleteTodo(todoId));
  };

  const value = (e) => {
    inputsValue = updateText.current.value;
    console.log(inputsValue);
    dispatch(updateTodo(inputsValue, id));
    dispatch(editbtn(id));
    e.preventDefault();
  };
  const updateState = (id) => {
    dispatch(editbtn(id));
  };
  return (
    <form onSubmit={value}>
      <div class="flex justify-start items-center p-2 hover:bg-gray-100 hover:transition-all space-x-4 border-b border-gray-400/20 last:border-0">
        <div
          class={`relative rounded-full bg-white border-2 border-gray-400 w-5 h-5 flex flex-shrink-0 justify-center items-center mr-2 ${
            completed && "border-green-500 focus-within:border-green-500"
          }`}
        >
          <input
            type="checkbox"
            class="opacity-0 absolute rounded-full"
            onClick={() => checked(todo.id)}
          />
          {completed && (
            <svg
              class=" fill-current w-3 h-3 text-green-500 pointer-events-none"
              viewBox="0 0 20 20"
            >
              <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
            </svg>
          )}
        </div>

        <div class="select-none flex-1 ">
          {ids === todo.id && status ? (
            <input ref={updateText} type={text} defaultValue={text}></input>
          ) : (
            <p>{text}</p>
          )}
        </div>
        <div className="cursor-pointer" onClick={() => updateState(todo.id)}>
          <svg
            class=" fill-current w-3 h-3 text-slate-500 pointer-events-none"
            viewBox="0 0 512 512"
          >
            <path d="M490.3 40.4C512.2 62.27 512.2 97.73 490.3 119.6L460.3 149.7L362.3 51.72L392.4 21.66C414.3-.2135 449.7-.2135 471.6 21.66L490.3 40.4zM172.4 241.7L339.7 74.34L437.7 172.3L270.3 339.6C264.2 345.8 256.7 350.4 248.4 353.2L159.6 382.8C150.1 385.6 141.5 383.4 135 376.1C128.6 370.5 126.4 361 129.2 352.4L158.8 263.6C161.6 255.3 166.2 247.8 172.4 241.7V241.7zM192 63.1C209.7 63.1 224 78.33 224 95.1C224 113.7 209.7 127.1 192 127.1H96C78.33 127.1 64 142.3 64 159.1V416C64 433.7 78.33 448 96 448H352C369.7 448 384 433.7 384 416V319.1C384 302.3 398.3 287.1 416 287.1C433.7 287.1 448 302.3 448 319.1V416C448 469 405 512 352 512H96C42.98 512 0 469 0 416V159.1C0 106.1 42.98 63.1 96 63.1H192z" />
          </svg>
        </div>
        {ids === todo.id && status ? (
          <button className="cursor-pointer" type="submit">
            <svg
              class=" fill-current w-3 h-3 text-blue-500 pointer-events-none"
              viewBox="0 0 448 512"
            >
              <path d="M438.6 105.4C451.1 117.9 451.1 138.1 438.6 150.6L182.6 406.6C170.1 419.1 149.9 419.1 137.4 406.6L9.372 278.6C-3.124 266.1-3.124 245.9 9.372 233.4C21.87 220.9 42.13 220.9 54.63 233.4L159.1 338.7L393.4 105.4C405.9 92.88 426.1 92.88 438.6 105.4H438.6z" />
            </svg>
          </button>
        ) : (
          ""
        )}

        <div
          onClick={() => colorSelect("green", id)}
          class={`flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer border-green-500 hover:bg-green-500 ${
            color === "green" && "bg-green-500"
          } `}
        ></div>

        <div
          onClick={() => colorSelect("yellow", id)}
          class={`flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer border-yellow-500 hover:bg-yellow-500 ${
            color === "yellow" && "bg-yellow-500"
          }`}
        ></div>

        <div
          onClick={() => colorSelect("red", id)}
          class={`flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer border-red-500 hover:bg-red-500 ${
            color === "red" && "bg-red-500"
          } `}
        ></div>

        <img
          src={cencle}
          class="flex-shrink-0 w-4 h-4 ml-2 cursor-pointer"
          alt="Cancel"
          onClick={() => deleting(id)}
        />
      </div>
    </form>
  );
}
